import { arrayOf, bool, func, number, object, string } from 'prop-types';
import React from 'react';
import { Alert } from 'reactstrap';

import { campaignProductMetaShape } from '../../prop-types';
import ContentfulCreativeTable from './ContentfulCreativeTable';
import ContentIds from './ContentIds/ContentIds';

function ContentfulCreativesTab({
  campaignLineProducts,
  campaignProductTags,
  campaignRelatedProducts,
  contentfulCreatives,
  onUpdateContentfulCreatives,
  onChangeCampaign,
  onSuccess,
  campaignProductMetas,
  onDelete,
  onSave,
  campaignId,
}) {
  const noCreativesAdded = contentfulCreatives.length === 0;
  return (
    <>
      <div>
        <ContentIds
          onSuccess={onSuccess}
          campaignLineProducts={campaignLineProducts}
          noCreativesAdded={noCreativesAdded}
          campaignId={campaignId}
        />
      </div>
      <div>
        {noCreativesAdded ? (
          <Alert color="warning" className="my-3">
            Please add some Content Ids for the campaign.
          </Alert>
        ) : (
          <ContentfulCreativeTable
            contentfulCreatives={contentfulCreatives}
            campaignLineProducts={campaignLineProducts}
            campaignProductTags={campaignProductTags}
            campaignRelatedProducts={campaignRelatedProducts}
            onUpdateContentfulCreatives={onUpdateContentfulCreatives}
            campaignProductMetas={campaignProductMetas}
            onChangeCampaign={onChangeCampaign}
            onDelete={onDelete}
            onSave={onSave}
          />
        )}
      </div>
    </>
  );
}

ContentfulCreativesTab.propTypes = {
  campaignLineProducts: arrayOf(object), // eslint-disable-line react/forbid-prop-types
  campaignRelatedProducts: bool,
  campaignProductTags: arrayOf(string),
  onChangeCampaign: func.isRequired,
  onSuccess: func.isRequired,
  onUpdateContentfulCreatives: func.isRequired,
  campaignProductMetas: arrayOf(campaignProductMetaShape.isRequired).isRequired,
  onDelete: func.isRequired,
  onSave: func.isRequired,
  contentfulCreatives: arrayOf(object), // eslint-disable-line react/forbid-prop-types
  campaignId: number.isRequired,
};

ContentfulCreativesTab.defaultProps = {
  campaignRelatedProducts: false,
  campaignProductTags: [],
  campaignLineProducts: [],
  contentfulCreatives: [{}],
};

export default ContentfulCreativesTab;
